import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../../../HtmlContent";
import styles from "./Suffix.style";

const SuffixStyled = styled.div((props) => ({ ...styles(props) }));

const Suffix = ({ label, error, width, size, className, ...rest }) => {
    if (!label) {
        return null;
    }

    return (
        <SuffixStyled error={error} suffixWidth={width} size={size} className={className} {...rest}>
            <HtmlContent content={label} wrapperComponent="div" />
        </SuffixStyled>
    );
};

const suffixSizes = Object.freeze({
    SMALL: "small",
    NORMAL: "normal",
    LARGE: "large",
});

Suffix.propTypes = {
    label: PropTypes.string,
    error: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOf([...Object.values(suffixSizes)]),
    className: PropTypes.string,
};

Suffix.defaultProps = {
    label: undefined,
    error: false,
    width: undefined,
    size: suffixSizes.NORMAL,
    className: undefined,
};

export { suffixSizes };

export default Suffix;
